import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Deal_1 from '../../../assets/images/home_page_6/deals/01.png';
import Deal_2 from '../../../assets/images/home_page_6/deals/02.png';
import Deal_3 from '../../../assets/images/home_page_6/deals/03.png';
import Deal_4 from '../../../assets/images/home_page_6/deals/04.png';
import Deal_5 from '../../../assets/images/home_page_6/deals/05.png';
import Deal_6 from '../../../assets/images/home_page_6/deals/06.png';
import Deal_7 from '../../../assets/images/home_page_6/deals/07.png';
import Deal_8 from '../../../assets/images/home_page_6/deals/08.png';

const dealsData = {
    "Latest Products": [
        {
            id: 1,
            image: Deal_1,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
        {
            id: 2,
            image: Deal_2,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
        {
            id: 3,
            image: Deal_3,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
        {
            id: 4,
            image: Deal_4,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
        {
            id: 5,
            image: Deal_5,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
        {
            id: 6,
            image: Deal_6,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
        {
            id: 7,
            image: Deal_7,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
        {
            id: 8,
            image: Deal_8,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },

    ],


    "Top Rating": [
        {
            id: 5,
            image: Deal_5,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
        {
            id: 6,
            image: Deal_6,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
        {
            id: 7,
            image: Deal_7,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
        {
            id: 8,
            image: Deal_8,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
    ],
    "Best Selling": [
        {
            id: 9,
            image: Deal_1,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
        {
            id: 10,
            image: Deal_2,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
        {
            id: 11,
            image: Deal_3,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
        {
            id: 12,
            image: Deal_4,
            title: 'Sony A7 III Mirrorless Camera with',
            price: '$159.77',
            seller: 'Offex',
            category: 'HTML',
            sales: 12,
        },
    ],
};

const Deals = () => {
    const [ActiveTab, setActiveTab] = useState('Latest Products');


    const handleTabchange = (tab) => {
        setActiveTab(tab);
    }

    return (
        <section id="deals-product-six" className="deals-product-six-main-block">
            <div className="container">
                <div className="deals-product-six-border">
                    <div className="row">
                        <div className="col-lg-4 col-md-5">
                            <div className="section">
                                <h6 className="section-heading-six">Deals Of The Day</h6>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-7">
                            <ul className="nav nav-pills float-lg-end float-start"
                                id="pills-tab"
                                role="tablist">
                                <li className="nav-item" role="presentation">
                                    <Link className={`nav-link ${ActiveTab === "Latest Products" ? "active" : ""}`}
                                        id="pills-tab1-tab"
                                        onClick={() => handleTabchange("Latest Products")}
                                        data-bs-toggle="pill"
                                        to="#pills-tab1" role="tab"
                                        aria-controls="pills-tab1"
                                        aria-selected="true">Latest Products</Link>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <Link className={`nav-link ${ActiveTab === "Top Rating" ? "active" : ""}`}
                                        id="pills-tab2-tab"
                                        onClick={() => handleTabchange("Top Rating")}
                                        data-bs-toggle="pill"
                                        to="#pills-tab2" role="tab"
                                        aria-controls="pills-tab2"
                                        aria-selected="false">Top Rating</Link>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <Link className={`nav-link ${ActiveTab === "Best Selling" ? "active" : ""}`}
                                        id="pills-tab3-tab"
                                        onClick={() => handleTabchange("Best Selling")}
                                        data-bs-toggle="pill"
                                        to="#pills-tab3" role="tab"
                                        aria-controls="pills-tab3"
                                        aria-selected="false">Best Selling</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="tab-content" id="pills-tabContent">
                    <div className={`tab-pane fade ${ActiveTab === 'Latest Products' ? 'show active' : ''}`}

                        id="pills-tab1"
                        role="tabpanel"

                        aria-labelledby="pills-tab1-tab"
                    >
                        <div className="row">
                            <div className="col-lg-3 col-md-6">
                                <div className="deals-day-six-block">
                                    <div className="deals-day-six-img">
                                        <Link to="/ShopDetails" title="">
                                            <img
                                                src={Deal_1}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </Link>
                                        <span className="badge text-bg-primary">$159.77</span>
                                    </div>
                                    <div className="deals-day-six-dtl">
                                        <h6 className="day-six-heading">
                                            <Link to="/ShopDetails" title="">
                                                Sony A7 III Mirrorless Camera with
                                            </Link>
                                        </h6>
                                        <p className="day-six-about">
                                            By <span>Offex</span> in <span>HTML</span>
                                        </p>
                                        <div className="deals-day-six-sale-icon">
                                            <Link to="#" title="">
                                                <i className="flaticon-shopping-cart" /> 12 Sale
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="deals-day-six-block">
                                    <div className="deals-day-six-img">
                                        <Link to="/ShopDetails" title="">
                                            <img
                                                src={Deal_2}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </Link>
                                        <span className="badge text-bg-primary">$159.77</span>
                                    </div>
                                    <div className="deals-day-six-dtl">
                                        <h6 className="day-six-heading">
                                            <Link to="/ShopDetails" title="">
                                                Sony A7 III Mirrorless Camera with
                                            </Link>
                                        </h6>
                                        <p className="day-six-about">
                                            By <span>Offex</span> in <span>HTML</span>
                                        </p>
                                        <div className="deals-day-six-sale-icon">
                                            <Link to="#" title="">
                                                <i className="flaticon-shopping-cart" /> 12 Sale
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="deals-day-six-block">
                                    <div className="deals-day-six-img">
                                        <Link to="/ShopDetails" title="">
                                            <img
                                                src={Deal_3}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </Link>
                                        <span className="badge text-bg-primary">$159.77</span>
                                    </div>
                                    <div className="deals-day-six-dtl">
                                        <h6 className="day-six-heading">
                                            <Link to="/ShopDetails" title="">
                                                Sony A7 III Mirrorless Camera with
                                            </Link>
                                        </h6>
                                        <p className="day-six-about">
                                            By <span>Offex</span> in <span>HTML</span>
                                        </p>
                                        <div className="deals-day-six-sale-icon">
                                            <Link to="#" title="">
                                                <i className="flaticon-shopping-cart" /> 12 Sale
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="deals-day-six-block">
                                    <div className="deals-day-six-img">
                                        <Link to="/ShopDetails" title="">
                                            <img
                                                src={Deal_4}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </Link>
                                        <span className="badge text-bg-primary">$159.77</span>
                                    </div>
                                    <div className="deals-day-six-dtl">
                                        <h6 className="day-six-heading">
                                            <Link to="/ShopDetails" title="">
                                                Sony A7 III Mirrorless Camera with
                                            </Link>
                                        </h6>
                                        <p className="day-six-about">
                                            By <span>Offex</span> in <span>HTML</span>
                                        </p>
                                        <div className="deals-day-six-sale-icon">
                                            <Link to="#" title="">
                                                <i className="flaticon-shopping-cart" /> 12 Sale
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="deals-day-six-block">
                                    <div className="deals-day-six-img">
                                        <Link to="/ShopDetails" title="">
                                            <img
                                                src={Deal_5}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </Link>
                                        <span className="badge text-bg-primary">$159.77</span>
                                    </div>
                                    <div className="deals-day-six-dtl">
                                        <h6 className="day-six-heading">
                                            <Link to="/ShopDetails" title="">
                                                Sony A7 III Mirrorless Camera with
                                            </Link>
                                        </h6>
                                        <p className="day-six-about">
                                            By <span>Offex</span> in <span>HTML</span>
                                        </p>
                                        <div className="deals-day-six-sale-icon">
                                            <Link to="#" title="">
                                                <i className="flaticon-shopping-cart" /> 12 Sale
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="deals-day-six-block">
                                    <div className="deals-day-six-img">
                                        <Link to="/ShopDetails" title="">
                                            <img
                                                src={Deal_6}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </Link>
                                        <span className="badge text-bg-primary">$159.77</span>
                                    </div>
                                    <div className="deals-day-six-dtl">
                                        <h6 className="day-six-heading">
                                            <Link to="/ShopDetails" title="">
                                                Sony A7 III Mirrorless Camera with
                                            </Link>
                                        </h6>
                                        <p className="day-six-about">
                                            By <span>Offex</span> in <span>HTML</span>
                                        </p>
                                        <div className="deals-day-six-sale-icon">
                                            <Link to="#" title="">
                                                <i className="flaticon-shopping-cart" /> 12 Sale
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="deals-day-six-block">
                                    <div className="deals-day-six-img">
                                        <Link to="/ShopDetails" title="">
                                            <img
                                                src={Deal_7}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </Link>
                                        <span className="badge text-bg-primary">$159.77</span>
                                    </div>
                                    <div className="deals-day-six-dtl">
                                        <h6 className="day-six-heading">
                                            <Link to="/ShopDetails" title="">
                                                Sony A7 III Mirrorless Camera with
                                            </Link>
                                        </h6>
                                        <p className="day-six-about">
                                            By <span>Offex</span> in <span>HTML</span>
                                        </p>
                                        <div className="deals-day-six-sale-icon">
                                            <Link to="#" title="">
                                                <i className="flaticon-shopping-cart" /> 12 Sale
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="deals-day-six-block">
                                    <div className="deals-day-six-img">
                                        <Link to="/ShopDetails" title="">
                                            <img
                                                src={Deal_8}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </Link>
                                        <span className="badge text-bg-primary">$159.77</span>
                                    </div>
                                    <div className="deals-day-six-dtl">
                                        <h6 className="day-six-heading">
                                            <Link to="/ShopDetails" title="">
                                                Sony A7 III Mirrorless Camera with
                                            </Link>
                                        </h6>
                                        <p className="day-six-about">
                                            By <span>Offex</span> in <span>HTML</span>
                                        </p>
                                        <div className="deals-day-six-sale-icon">
                                            <Link to="#" title="">
                                                <i className="flaticon-shopping-cart" /> 12 Sale
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`tab-pane fade ${ActiveTab === 'Top Rating' ? 'show active' : ''}`}
                        id="pills-tab2"
                        role="tabpanel"
                        aria-labelledby="pills-tab2-tab"
                    >
                        <div className="row">
                            <div className="col-lg-3 col-md-6">
                                <div className="deals-day-six-block">
                                    <div className="deals-day-six-img">
                                        <Link to="/ShopDetails" title="">
                                            <img
                                                src={Deal_1}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </Link>
                                        <span className="badge text-bg-primary">$159.77</span>
                                    </div>
                                    <div className="deals-day-six-dtl">
                                        <h6 className="day-six-heading">
                                            <Link to="/ShopDetails" title="">
                                                Sony A7 III Mirrorless Camera with
                                            </Link>
                                        </h6>
                                        <p className="day-six-about">
                                            By <span>Offex</span> in <span>HTML</span>
                                        </p>
                                        <div className="deals-day-six-sale-icon">
                                            <Link to="#" title="">
                                                <i className="flaticon-shopping-cart" /> 12 Sale
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="deals-day-six-block">
                                    <div className="deals-day-six-img">
                                        <Link to="/ShopDetails" title="">
                                            <img
                                                src={Deal_2}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </Link>
                                        <span className="badge text-bg-primary">$159.77</span>
                                    </div>
                                    <div className="deals-day-six-dtl">
                                        <h6 className="day-six-heading">
                                            <Link to="/ShopDetails" title="">
                                                Sony A7 III Mirrorless Camera with
                                            </Link>
                                        </h6>
                                        <p className="day-six-about">
                                            By <span>Offex</span> in <span>HTML</span>
                                        </p>
                                        <div className="deals-day-six-sale-icon">
                                            <Link to="#" title="">
                                                <i className="flaticon-shopping-cart" /> 12 Sale
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="deals-day-six-block">
                                    <div className="deals-day-six-img">
                                        <Link to="/ShopDetails" title="">
                                            <img
                                                src={Deal_3}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </Link>
                                        <span className="badge text-bg-primary">$159.77</span>
                                    </div>
                                    <div className="deals-day-six-dtl">
                                        <h6 className="day-six-heading">
                                            <Link to="/ShopDetails" title="">
                                                Sony A7 III Mirrorless Camera with
                                            </Link>
                                        </h6>
                                        <p className="day-six-about">
                                            By <span>Offex</span> in <span>HTML</span>
                                        </p>
                                        <div className="deals-day-six-sale-icon">
                                            <Link to="#" title="">
                                                <i className="flaticon-shopping-cart" /> 12 Sale
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="deals-day-six-block">
                                    <div className="deals-day-six-img">
                                        <Link to="/ShopDetails" title="">
                                            <img
                                                src={Deal_4}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </Link>
                                        <span className="badge text-bg-primary">$159.77</span>
                                    </div>
                                    <div className="deals-day-six-dtl">
                                        <h6 className="day-six-heading">
                                            <Link to="/ShopDetails" title="">
                                                Sony A7 III Mirrorless Camera with
                                            </Link>
                                        </h6>
                                        <p className="day-six-about">
                                            By <span>Offex</span> in <span>HTML</span>
                                        </p>
                                        <div className="deals-day-six-sale-icon">
                                            <Link to="#" title="">
                                                <i className="flaticon-shopping-cart" /> 12 Sale
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`tab-pane fade ${ActiveTab === 'Best Selling' ? 'show active' : ''}`}
                        id="pills-tab3"
                        role="tabpanel" aria-labelledby="pills-tab3-tab" >
                        <div className="row">
                            <div className="col-lg-3 col-md-6">
                                <div className="deals-day-six-block">
                                    <div className="deals-day-six-img">
                                        <Link to="/ShopDetails" title="">
                                            <img
                                                src={Deal_5}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </Link>
                                        <span className="badge text-bg-primary">$159.77</span>
                                    </div>
                                    <div className="deals-day-six-dtl">
                                        <h6 className="day-six-heading">
                                            <Link to="/ShopDetails" title="">
                                                Sony A7 III Mirrorless Camera with
                                            </Link>
                                        </h6>
                                        <p className="day-six-about">
                                            By <span>Offex</span> in <span>HTML</span>
                                        </p>
                                        <div className="deals-day-six-sale-icon">
                                            <Link to="#" title="">
                                                <i className="flaticon-shopping-cart" /> 12 Sale
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="deals-day-six-block">
                                    <div className="deals-day-six-img">
                                        <Link to="/ShopDetails" title="">
                                            <img
                                                src={Deal_6}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </Link>
                                        <span className="badge text-bg-primary">$159.77</span>
                                    </div>
                                    <div className="deals-day-six-dtl">
                                        <h6 className="day-six-heading">
                                            <Link to="/ShopDetails" title="">
                                                Sony A7 III Mirrorless Camera with
                                            </Link>
                                        </h6>
                                        <p className="day-six-about">
                                            By <span>Offex</span> in <span>HTML</span>
                                        </p>
                                        <div className="deals-day-six-sale-icon">
                                            <Link to="#" title="">
                                                <i className="flaticon-shopping-cart" /> 12 Sale
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="deals-day-six-block">
                                    <div className="deals-day-six-img">
                                        <Link to="/ShopDetails" title="">
                                            <img
                                                src={Deal_7}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </Link>
                                        <span className="badge text-bg-primary">$159.77</span>
                                    </div>
                                    <div className="deals-day-six-dtl">
                                        <h6 className="day-six-heading">
                                            <Link to="/ShopDetails" title="">
                                                Sony A7 III Mirrorless Camera with
                                            </Link>
                                        </h6>
                                        <p className="day-six-about">
                                            By <span>Offex</span> in <span>HTML</span>
                                        </p>
                                        <div className="deals-day-six-sale-icon">
                                            <Link to="#" title="">
                                                <i className="flaticon-shopping-cart" /> 12 Sale
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="deals-day-six-block">
                                    <div className="deals-day-six-img">
                                        <Link to="/ShopDetails" title="">
                                            <img
                                                src={Deal_8}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </Link>
                                        <span className="badge text-bg-primary">$159.77</span>
                                    </div>
                                    <div className="deals-day-six-dtl">
                                        <h6 className="day-six-heading">
                                            <Link to="/ShopDetails" title="">
                                                Sony A7 III Mirrorless Camera with
                                            </Link>
                                        </h6>
                                        <p className="day-six-about">
                                            By <span>Offex</span> in <span>HTML</span>
                                        </p>
                                        <div className="deals-day-six-sale-icon">
                                            <Link to="#" title="">
                                                <i className="flaticon-shopping-cart" /> 12 Sale
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
};

export default Deals;